import React from "react";
import { Icon } from "@tvg/design-system";
import { trackBetaFeatureFeedback } from "@urp/alchemer";

import { NullaryFn } from "@tvg/ts-types/Functional";
import { Container, IconContainer, Divider } from "./styled-components";

interface Props {
  apptentiveEvent: NullaryFn<void>;
}

const handleOnClick = (apptentiveEvent: NullaryFn<void>) => () => {
  apptentiveEvent();
  trackBetaFeatureFeedback();
};

const FeedbackButton = ({ apptentiveEvent }: Props) => (
  <Container
    data-qa-label="feedback-btn-container"
    onClick={handleOnClick(apptentiveEvent)}
  >
    <IconContainer>
      <Icon
        name="feedback"
        size="m"
        lineColor="blue_accent.000"
        backgroundColor="blue_accent.000"
      />
    </IconContainer>
    <Divider />
    <span>Feedback</span>
  </Container>
);

export default FeedbackButton;
